import { CODEX_BY_CATEGORY, FIRST_STEPS } from '@deepwake/shared';

/** Codex reader + first-flight checklist. */
export class CodexUi {
  panel: HTMLElement;
  steps: HTMLElement;
  done = new Set<string>(JSON.parse(localStorage.getItem('deepwake.firststeps') ?? '[]'));

  constructor(root: HTMLElement) {
    this.panel = document.createElement('div');
    this.panel.id = 'codex';
    this.panel.className = 'panel hidden';
    root.appendChild(this.panel);

    this.steps = document.createElement('div');
    this.steps.id = 'firststeps';
    this.steps.className = 'panel';
    root.appendChild(this.steps);

    const btn = document.createElement('button');
    btn.id = 'codexbtn';
    btn.textContent = 'Codex';
    btn.addEventListener('click', () => this.toggle());
    root.appendChild(btn);

    this.renderSteps();
  }

  toggle(): void {
    this.panel.classList.toggle('hidden');
    if (!this.panel.classList.contains('hidden')) this.renderCodex();
  }

  private renderCodex(openId?: string): void {
    this.panel.innerHTML = `
      <div class="cdx-head"><div class="ptitle">Codex of the Reach</div><button id="cdx-close">✕</button></div>
      <div class="cdx-body">
        <div class="cdx-nav">${CODEX_BY_CATEGORY.map(
          (c) => `<div class="cdx-cat">${c.category}</div>${c.entries
            .map((e) => `<div class="cdx-link ${e.id === openId ? 'sel' : ''}" data-id="${e.id}">${e.title}</div>`)
            .join('')}`,
        ).join('')}</div>
        <div class="cdx-text" id="cdx-text"></div>
      </div>`;
    this.panel.querySelector('#cdx-close')!.addEventListener('click', () => this.toggle());
    const entries = CODEX_BY_CATEGORY.flatMap((c) => c.entries);
    const show = (id: string) => {
      const e = entries.find((x) => x.id === id) ?? entries[0];
      const el = this.panel.querySelector('#cdx-text') as HTMLElement;
      el.innerHTML = `<h2></h2>${e.body
        .split('\n\n')
        .map(() => '<p></p>')
        .join('')}`;
      (el.querySelector('h2') as HTMLElement).textContent = e.title;
      const ps = el.querySelectorAll('p');
      e.body.split('\n\n').forEach((para, i) => ((ps[i] as HTMLElement).textContent = para));
      this.panel.querySelectorAll('.cdx-link').forEach((l) => l.classList.toggle('sel', (l as HTMLElement).dataset.id === e.id));
    };
    this.panel.querySelectorAll<HTMLElement>('.cdx-link').forEach((l) =>
      l.addEventListener('click', () => show(l.dataset.id!)),
    );
    show(openId ?? 'reach');
  }

  /** Mark a first-step done (idempotent). */
  step(id: string): void {
    if (this.done.has(id)) return;
    this.done.add(id);
    localStorage.setItem('deepwake.firststeps', JSON.stringify([...this.done]));
    this.renderSteps();
  }

  private renderSteps(): void {
    const remaining = FIRST_STEPS.filter((s) => !this.done.has(s.id));
    if (remaining.length === 0) {
      this.steps.classList.add('hidden');
      return;
    }
    this.steps.classList.remove('hidden');
    this.steps.innerHTML = `<div class="ptitle">First flight</div>${FIRST_STEPS.map(
      (s) => `<div class="step ${this.done.has(s.id) ? 'done' : ''}">${this.done.has(s.id) ? '✓' : '·'} ${s.label}</div>`,
    ).join('')}`;
  }
}
